// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NJDLGmUvAM6VQvoKdyl6R"};